/**
 * Page « Frais » — les coûts que l'équipe saisit, et qu'aucune API ne
 * connaît : coût d'envoi par commande, frais Shopify Payments, coût de revient
 * d'un kit Piano LED par période, coût des autres articles (variantes
 * Shopify), retenues sur le CA des abonnements (Sacem, Fees Stripe…), dépenses
 * de branding (MC3).
 *
 * Réglages communs à tous les admins, lus par les pages de ventes (COGS,
 * Shipping costs, marges par canal, MC2 du Résumé). Ils vivent ici pour
 * laisser le Résumé aux chiffres.
 */

import { ArticleCostsEditor } from '../components/ArticleCostsEditor';
import { BrandingEditor } from '../components/BrandingEditor';
import { DeductionsEditor } from '../components/DeductionsEditor';
import { KitCostPeriodsEditor } from '../components/KitCostPeriodsEditor';
import { Layout } from '../components/Layout';
import { ShopCostSettings } from '../components/ShopCostSettings';
import { useAuth } from '../hooks/useAuth';

export function FraisPage() {
  const { email, signOut } = useAuth();

  return (
    <Layout email={email} onSignOut={signOut}>
      <h1 className="page-title">
        Frais
        <span className="page-title__sub">Coûts unitaires saisis à la main : envoi, coût de revient du kit par période, coût des articles</span>
      </h1>
      <ShopCostSettings />
      <KitCostPeriodsEditor />
      <ArticleCostsEditor />
      <DeductionsEditor />
      <BrandingEditor />
    </Layout>
  );
}
